import { render, staticRenderFns } from "./PersonalTotpSettings.vue?vue&type=template&id=b38afb0e&scoped=true"
import script from "./PersonalTotpSettings.vue?vue&type=script&lang=js"
export * from "./PersonalTotpSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalTotpSettings.vue?vue&type=style&index=0&id=b38afb0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38afb0e",
  null
  
)

export default component.exports